import { z } from 'zod'

import { PathField } from '../pathFields'
import { EasyBuilderConfigFormSectionType } from '../viewSectionTypes'

export enum FormProductGalleryVariant {
  ONE_CARD = 'oneCard',
  MULTI_CARDS = 'multiCards',
}

const viewSectionFormProductGalleryOneCardSchema = z.object({
  displayType: z.literal(EasyBuilderConfigFormSectionType.DM_GALLERY_CARDS),
  variant: z.literal(FormProductGalleryVariant.ONE_CARD),
  path: z.object({
    card: z.literal(PathField.DM_GALLERY_CARD_1),
    link1: z.literal(PathField.DM_GALLERY_CARD_1_BUTTON_1),
    link2: z.literal(PathField.DM_GALLERY_CARD_1_BUTTON_2),
    link3: z.literal(PathField.DM_GALLERY_CARD_1_BUTTON_3),
  }),
})

const viewSectionFormProductGalleryMultiCardsSchema = z.object({
  displayType: z.literal(EasyBuilderConfigFormSectionType.DM_GALLERY_CARDS),
  variant: z.literal(FormProductGalleryVariant.MULTI_CARDS).optional(),
  path: z.object({
    // TODO: Expand for more than 1 card
    card_1: z.literal(PathField.DM_GALLERY_CARD_1),
    card_1_link1: z.literal(PathField.DM_GALLERY_CARD_1_BUTTON_1),
    card_1_link2: z.literal(PathField.DM_GALLERY_CARD_1_BUTTON_2),
    card_1_link3: z.literal(PathField.DM_GALLERY_CARD_1_BUTTON_3),
  }),
})

export const viewSectionFormProductGallerySchema = z.union([
  viewSectionFormProductGalleryOneCardSchema,
  viewSectionFormProductGalleryMultiCardsSchema,
])
